var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBancoLivesRevalida(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-banco-lives-revalida",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112.337,
    height: 72.437,
    viewBox: "0 0 112.337 72.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-4 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-5 {\r\n        clip-path: url(#clip-path-2);\r\n      }\r\n\r\n      .cls-6 {\r\n        clip-path: url(#clip-path-4);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.552,
    y1: -0.19,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.491,
    y1: -0.536,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#09d785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2917",
    "data-name": "Ret\\xE2ngulo 2917",
    className: "cls-1",
    width: 112.337,
    height: 72.437
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3529",
    "data-name": "Caminho 3529",
    className: "cls-2",
    d: "M5.226,53.816A2.972,2.972,0,1,1,8.2,56.788a2.971,2.971,0,0,1-2.972-2.972m14.386-3.032h3.012V71.4H30.7v2.449H19.612Zm15.953,0h3.011V73.852H35.565Zm25.682,0h3.177l-8.7,23.068H52.245l-8.7-23.068h3.21L54,70.676Zm8.142-.033H81.8v2.482H72.4v7.712h8.406v2.482H72.4V71.37h9.4v2.482H69.389ZM98.728,70.46A3.488,3.488,0,0,0,99.969,67.7a3.135,3.135,0,0,0-.728-2.15,4.654,4.654,0,0,0-1.82-1.258,28.519,28.519,0,0,0-2.945-.926,25.857,25.857,0,0,1-3.657-1.192,5.877,5.877,0,0,1-2.351-1.87,5.491,5.491,0,0,1-.976-3.426,5.935,5.935,0,0,1,.96-3.342,6.262,6.262,0,0,1,2.7-2.251,9.509,9.509,0,0,1,3.989-.794,8.352,8.352,0,0,1,5.311,1.621,5.994,5.994,0,0,1,2.334,4.3h-3.31a3.573,3.573,0,0,0-1.39-2.334,4.944,4.944,0,0,0-3.243-1.01,4.7,4.7,0,0,0-3.078.976,3.335,3.335,0,0,0-1.192,2.73,2.958,2.958,0,0,0,.711,2.053,4.593,4.593,0,0,0,1.754,1.208q1.043.414,2.929.943a27.61,27.61,0,0,1,3.674,1.241,6.133,6.133,0,0,1,2.383,1.886,5.481,5.481,0,0,1,.993,3.459,6.071,6.071,0,0,1-.893,3.178,6.57,6.57,0,0,1-2.648,2.416,8.729,8.729,0,0,1-4.136.927,9.874,9.874,0,0,1-4.088-.811,6.809,6.809,0,0,1-2.83-2.251A5.763,5.763,0,0,1,87.36,67.7h3.21a4.225,4.225,0,0,0,1.34,2.731,4.809,4.809,0,0,0,3.426,1.109,5,5,0,0,0,3.392-1.076M93.943,45.851H0V67.91l11.183-.005v2.345H0v9.574H112.337v-1.86H48.908V75.982h63.429V45.851Z",
    transform: "translate(0 -45.851)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3532",
    "data-name": "Caminho 3532",
    className: "cls-3",
    d: "M78.756,138.9l-4.38,12.727-4.4-12.727h-3.44L72.4,154.9h3.9l5.87-16.006Z",
    transform: "translate(-66.534 -138.896)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5989",
    "data-name": "Grupo 5989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5988",
    "data-name": "Grupo 5988",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3522",
    "data-name": "Caminho 3522",
    d: "M11.5,9.394a3.783,3.783,0,0,1,.813,2.387,3.792,3.792,0,0,1-1.352,3.068,5.708,5.708,0,0,1-3.772,1.133H0V.542H6.95a5.7,5.7,0,0,1,3.684,1.077,3.565,3.565,0,0,1,1.331,2.925,3.528,3.528,0,0,1-.715,2.266,3.692,3.692,0,0,1-1.9,1.254A3.6,3.6,0,0,1,11.5,9.394M3.761,6.788H6.224a2.182,2.182,0,0,0,1.418-.406,1.462,1.462,0,0,0,.495-1.2,1.492,1.492,0,0,0-.495-1.209,2.137,2.137,0,0,0-1.418-.418H3.761Zm4.234,5.729a1.522,1.522,0,0,0,.517-1.242A1.594,1.594,0,0,0,7.973,10a2.212,2.212,0,0,0-1.485-.462H3.761v3.41H6.532a2.228,2.228,0,0,0,1.462-.429",
    transform: "translate(0 -0.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3523",
    "data-name": "Caminho 3523",
    d: "M43.807,13.256H38.046l-.925,2.727H33.184L38.771.543h4.355l5.586,15.439H44.732Zm-.967-2.9L40.926,4.7l-1.892,5.653Z",
    transform: "translate(-19.702 -0.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3524",
    "data-name": "Caminho 3524",
    d: "M89.384,15.982H85.623l-6.29-9.523v9.523H75.572V.542h3.761l6.29,9.567V.542h3.761Z",
    transform: "translate(-44.869 -0.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3525",
    "data-name": "Caminho 3525",
    d: "M115.7,3.9a7.074,7.074,0,0,1,2.76-2.793,8.02,8.02,0,0,1,4.014-1,7.686,7.686,0,0,1,4.707,1.452A6.968,6.968,0,0,1,129.8,5.519h-4.135a3.343,3.343,0,0,0-1.308-1.474,3.681,3.681,0,0,0-1.925-.505,3.593,3.593,0,0,0-2.816,1.21,4.682,4.682,0,0,0-1.077,3.232,4.684,4.684,0,0,0,1.077,3.234,3.593,3.593,0,0,0,2.816,1.21,3.678,3.678,0,0,0,1.925-.507,3.333,3.333,0,0,0,1.308-1.473H129.8a6.916,6.916,0,0,1-2.617,3.947,7.724,7.724,0,0,1-4.707,1.441,8.02,8.02,0,0,1-4.014-1,7.1,7.1,0,0,1-2.76-2.783,8.242,8.242,0,0,1-.99-4.069,8.306,8.306,0,0,1,.99-4.08",
    transform: "translate(-68.106 -0.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3526",
    "data-name": "Caminho 3526",
    d: "M159.909,14.8a7.567,7.567,0,0,1-2.881-2.826,7.894,7.894,0,0,1-1.067-4.08,7.834,7.834,0,0,1,1.067-4.069,7.589,7.589,0,0,1,2.881-2.816,8.385,8.385,0,0,1,7.984,0,7.43,7.43,0,0,1,2.859,2.816A7.97,7.97,0,0,1,171.8,7.9a7.962,7.962,0,0,1-1.056,4.08,7.516,7.516,0,0,1-2.859,2.826,8.364,8.364,0,0,1-7.973,0m6.95-3.651A4.672,4.672,0,0,0,167.971,7.9,4.666,4.666,0,0,0,166.86,4.63,3.806,3.806,0,0,0,163.9,3.41a3.847,3.847,0,0,0-2.98,1.21A4.656,4.656,0,0,0,159.811,7.9a4.663,4.663,0,0,0,1.111,3.265,3.827,3.827,0,0,0,2.98,1.221,3.786,3.786,0,0,0,2.958-1.231",
    transform: "translate(-92.598 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3527",
    "data-name": "Caminho 3527",
    d: "M221.611,1.51a6.917,6.917,0,0,1,2.826,2.716,7.987,7.987,0,0,1,1,4.036,8,8,0,0,1-1,4.024,6.883,6.883,0,0,1-2.837,2.728,9,9,0,0,1-4.257.968H211.56V.543h5.784a8.981,8.981,0,0,1,4.267.967m-1.188,10.051a4.412,4.412,0,0,0,1.188-3.3,4.49,4.49,0,0,0-1.188-3.321A4.489,4.489,0,0,0,217.1,3.754h-1.782v8.974H217.1a4.537,4.537,0,0,0,3.321-1.166",
    transform: "translate(-125.607 -0.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3528",
    "data-name": "Caminho 3528",
    d: "M254.677,3.555V6.678h5.037v2.9h-5.037v3.388h5.7v3.013h-9.457V.542h9.457V3.555Z",
    transform: "translate(-148.974 -0.322)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5991",
    "data-name": "Grupo 5991",
    transform: "translate(0 18.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5990",
    "data-name": "Grupo 5990",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2918",
    "data-name": "Ret\\xE2ngulo 2918",
    className: "cls-2",
    width: 63.955,
    height: 117.355,
    transform: "translate(-9.099 31.331) rotate(-73.806)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5993",
    "data-name": "Grupo 5993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5992",
    "data-name": "Grupo 5992",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3530",
    "data-name": "Caminho 3530",
    d: "M8.3,154.9l-3.531-6.237H3.259V154.9H.049V138.9H6.057a7.014,7.014,0,0,1,3.164.654,4.563,4.563,0,0,1,1.961,1.766,4.82,4.82,0,0,1,.653,2.488,4.768,4.768,0,0,1-.917,2.855,4.714,4.714,0,0,1-2.729,1.754l3.829,6.489Zm-5.044-8.645H5.942a2.681,2.681,0,0,0,1.949-.631,2.346,2.346,0,0,0,.642-1.754,2.24,2.24,0,0,0-.642-1.708,2.748,2.748,0,0,0-1.949-.607H3.259Z",
    transform: "translate(-0.029 -82.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3531",
    "data-name": "Caminho 3531",
    d: "M41.13,141.454v4.013h5.389v2.545H41.13v4.242h6.077v2.614H37.92V138.84h9.287v2.614Z",
    transform: "translate(-22.514 -82.432)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5995",
    "data-name": "Grupo 5995",
    transform: "translate(27.031 56.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5994",
    "data-name": "Grupo 5994",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2920",
    "data-name": "Ret\\xE2ngulo 2920",
    className: "cls-3",
    width: 22.375,
    height: 22.362,
    transform: "translate(-7.992 8.417) rotate(-46.483)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5997",
    "data-name": "Grupo 5997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5996",
    "data-name": "Grupo 5996",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3533",
    "data-name": "Caminho 3533",
    d: "M119.835,151.819H113.46l-1.055,3.05h-3.37l5.755-16.028h3.737l5.755,16.028h-3.394Zm-.871-2.568-2.317-6.7-2.315,6.7Z",
    transform: "translate(-64.736 -82.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3534",
    "data-name": "Caminho 3534",
    d: "M156.775,152.357h5.274V154.9h-8.484V138.9h3.21Z",
    transform: "translate(-91.174 -82.466)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2921",
    "data-name": "Ret\\xE2ngulo 2921",
    width: 3.21,
    height: 16.006,
    transform: "translate(73.603 56.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3535",
    "data-name": "Caminho 3535",
    d: "M208.579,139.883a7.044,7.044,0,0,1,2.958,2.809,8.369,8.369,0,0,1,1.043,4.231,8.24,8.24,0,0,1-1.043,4.207,7.083,7.083,0,0,1-2.958,2.786,9.559,9.559,0,0,1-4.437.986h-5.595V138.9h5.595a9.56,9.56,0,0,1,4.437.986m-.653,10.915a5.239,5.239,0,0,0,1.376-3.875,5.359,5.359,0,0,0-1.376-3.91,5.2,5.2,0,0,0-3.9-1.411h-2.27v10.571h2.27a5.272,5.272,0,0,0,3.9-1.376",
    transform: "translate(-117.881 -82.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3536",
    "data-name": "Caminho 3536",
    d: "M249.081,151.819h-6.375l-1.055,3.05h-3.37l5.755-16.028h3.738l5.755,16.028h-3.394Zm-.871-2.568-2.316-6.7-2.316,6.7Z",
    transform: "translate(-141.472 -82.433)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBancoLivesRevalida);
export default __webpack_public_path__ + "static/media/logo-banco-lives-revalida.c0d3cb41ac89e0b3365207e40b3231e4.svg";
export { ForwardRef as ReactComponent };